exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu1 {\n  /*display: none !important;*/\n  width: 0px !important;\n  transition: width 0.3s ease-in-out !important;\n  overflow: hidden !important;\n  padding: 0px !important;\n}\n\n.side-effects {\n  width: 70% !important;\n  transition: width 0.3s ease-in-out !important;\n  overflow: hidden !important;\n}\n#list {\n  height: 0;\n  transition: height 1s ease-in-out;\n  overflow: hidden;\n  background: #d5d5d5;\n}\n.tm {\n  padding-right: 1rem !important;\n}\n\n.button-container {\n  gap: 24px\n}\n\n.button-icon {\n  margin-left: 24px;\n}\n", ""]);

// exports
